export const PinIcon = ({
  width = 12,
  height = 12,
  filled = false,
}: {
  width?: number;
  height?: number;
  filled?: boolean;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 8.5V11V8.5Z" fill="currentColor" />
      <path d="M6 8.5V11" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M4.49902 5.38C4.49892 5.56604 4.44693 5.74837 4.34888 5.90648C4.25084 6.06459 4.11063 6.19221 3.94402 6.275L3.05402 6.725C2.88742 6.80779 2.74721 6.93541 2.64916 7.09352C2.55112 7.25163 2.49912 7.43396 2.49902 7.62V8C2.49902 8.13261 2.5517 8.25979 2.64547 8.35355C2.73924 8.44732 2.86642 8.5 2.99902 8.5H8.99902C9.13163 8.5 9.25881 8.44732 9.35258 8.35355C9.44635 8.25979 9.49902 8.13261 9.49902 8V7.62C9.49893 7.43396 9.44693 7.25163 9.34888 7.09352C9.25084 6.93541 9.11063 6.80779 8.94402 6.725L8.05402 6.275C7.88742 6.19221 7.74721 6.06459 7.64916 5.90648C7.55112 5.74837 7.49912 5.56604 7.49902 5.38V3.5C7.49902 3.36739 7.5517 3.24021 7.64547 3.14645C7.73924 3.05268 7.86642 3 7.99902 3C8.26424 3 8.51859 2.89464 8.70613 2.70711C8.89367 2.51957 8.99902 2.26522 8.99902 2C8.99902 1.73478 8.89367 1.48043 8.70613 1.29289C8.51859 1.10536 8.26424 1 7.99902 1H3.99902C3.73381 1 3.47945 1.10536 3.29192 1.29289C3.10438 1.48043 2.99902 1.73478 2.99902 2C2.99902 2.26522 3.10438 2.51957 3.29192 2.70711C3.47945 2.89464 3.73381 3 3.99902 3C4.13163 3 4.25881 3.05268 4.35258 3.14645C4.44635 3.24021 4.49902 3.36739 4.49902 3.5V5.38Z"
        fill={filled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
